import { createUseStyles } from 'react-jss'

import { blue, lightGrey } from '../../../../../../../styles/const/colors'

const useStyles = createUseStyles({
  messageBlock: {
    background: 'white',
    borderColor: lightGrey
  },
  link: {
    textDecoration: 'none',
    color: [blue, '!important']
  }
})

export default useStyles
